import setPinnedJobsSection from "./SetPinnedJobsSection";
import updateFormValuePinnedData from "./UpdateFormValuePinnedData";
import updateHeaderPinnedCount from "./UpdateHeaderPinnedCount";

const updatePinnedJobs = (event) => {
   let pinnedJobs = JSON.parse(localStorage.getItem('pinnedJobs')) || [];
   let pinnedJobNames = JSON.parse(localStorage.getItem('pinnedJobNames')) || [];
   const jobId = event.target.dataset.jobId;
   const jobName = event.target.dataset.jobName;
   const index = pinnedJobs.indexOf(jobId);
   const activeButtonClass = 'pinned-job-button--active';

   if (index === -1) {
      pinnedJobs.unshift(jobId);
      pinnedJobNames.unshift(jobName);
      event.target.classList.add(activeButtonClass);
   } else {
      pinnedJobs.splice(index, 1);
      pinnedJobNames.splice(index, 1);
      event.target.classList.remove(activeButtonClass);
   }
   localStorage.setItem('pinnedJobs', JSON.stringify(pinnedJobs));
   localStorage.setItem('pinnedJobNames', JSON.stringify(pinnedJobNames));
   updateHeaderPinnedCount(pinnedJobs.length);
   const pinnedJobsSection = [...document.querySelectorAll('[data-js-pinned-jobs-section]')];
   if (pinnedJobsSection.length > 0) {
      setPinnedJobsSection();
   }
   const pinnedJobsContactFormSections = [...document.querySelectorAll('[data-contact-form-hidden-inputs]')];
   if (pinnedJobsContactFormSections.length > 0) {
      updateFormValuePinnedData();
   }
};

export default updatePinnedJobs;